import { StatementType } from "./index.js";
import { isIsValue, isNewStatement, isNullValue, isPeriodToken, isSemicolonToken, isStringToken } from "../helper.js";
//#region ../schema-sql-parser/dist/parser/statement/comment.on.column.js
function commentOnColumnParser(tokens, $pos) {
	const newStatement = isNewStatement(tokens);
	const isString = isStringToken(tokens);
	const isPeriod = isPeriodToken(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isIs = isIsValue(tokens);
	const isNull = isNullValue(tokens);
	const isToken = () => $pos.value < tokens.length;
	const ast = {
		type: StatementType.commentOnColumn,
		tableName: "",
		columnName: "",
		comment: ""
	};
	$pos.value += 3;
	const names = [];
	let isValue = false;
	while (isToken() && !newStatement($pos.value)) {
		let token = tokens[$pos.value];
		if (isSemicolon($pos.value)) {
			$pos.value++;
			break;
		}
		if (isIs($pos.value)) {
			isValue = true;
			token = tokens[++$pos.value];
			if (isNull($pos.value)) {
				$pos.value++;
				continue;
			}
			if (isString($pos.value)) {
				ast.comment = token.value;
				$pos.value++;
			}
			continue;
		}
		if (isPeriod($pos.value)) {
			$pos.value++;
			continue;
		}
		if (isString($pos.value) && !isValue) {
			names.push(token.value);
			$pos.value++;
			continue;
		}
		$pos.value++;
	}
	ast.columnName = names.length ? names[names.length - 1] : "";
	ast.tableName = names.length > 1 ? names[names.length - 2] : "";
	return ast;
}
//#endregion
export { commentOnColumnParser };
